import React from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import Link from "next/link";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";
import useDevice from "../../shared/customHooks/useDevice";

const StyledAdditionalFooter = styled.div`
  color: #000;
  a {
    color: ${({ theme }) => `${theme.primaryColor}`};
  }
`;

function AdditionalFooter() {
  const { footerStore, navigationStore } = useStores();

  const { additionalFooterNavigation } = navigationStore;

  const { additionalFooterNavigationText } = footerStore;

  const { isMobile } = useDevice();

  const styledAdditionalFooterClassName = classNames("d-flex", {
    "flex-column align-items-center": isMobile,
    "justify-content-between": !isMobile,
  });

  return (
    <StyledAdditionalFooter className={styledAdditionalFooterClassName}>
      {isMobile && (
        <div className="text-center mb-4">
          <span className="d-block mb-4">{additionalFooterNavigationText}</span>
          {additionalFooterNavigation.map((navLink) => {
            return (
              <p key={navLink.title}>
                <a href={navLink.externalPath}>{`${navLink.title}`}</a>
              </p>
            );
          })}
        </div>
      )}
      {!isMobile && (
        <div>
          {additionalFooterNavigationText && (
            <span className="me-1">{additionalFooterNavigationText}</span>
          )}
          {additionalFooterNavigation.map((navLink) => (
            <span key={navLink.title}>
              <span className="me-1">/</span>
              <a
                className="me-1"
                href={navLink.externalPath}
              >{`${navLink.title}`}</a>
            </span>
          ))}
        </div>
      )}
      <div>
        <span className="me-5">
          Site by <a href="https://talent-funnel.com">Talent Funnel</a>
        </span>
        <Link href="/sitemap">Sitemap</Link>
      </div>
    </StyledAdditionalFooter>
  );
}

export default observer(AdditionalFooter);
